import { ChangeDetectorRef, Component, EventEmitter, Input, LOCALE_ID, Output, ViewChild } from '@angular/core';
import { MbscCalendarEvent, MbscEventClickEvent, MbscModule, MbscPopup } from '@mobiscroll/angular';
import { categoryData, platformIcons, statusData } from '../../../interfaces/selectData';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { getCalendarOptions } from '../../../interfaces/calender/admin/calender-event-functions';
import { IconService } from '../../../services/shared/icons/icon.service';
import { ColorService } from '../../../services/shared/color/color.service';

@Component({
  selector: 'app-event-hover',
  imports: [MbscModule, CommonModule, ],
  providers: [DatePipe, { provide: LOCALE_ID, useValue: 'de' },],
  templateUrl: './event-hover.component.html',
  styleUrl: './event-hover.component.scss'
})
export class EventHoverComponent {
  //TOOLTIP
  @ViewChild('popup', { static: false })tooltip!: MbscPopup
  @Output() eventHoverIn: EventEmitter<any> = new EventEmitter();
  @Output() eventHoverOut: EventEmitter<any> = new EventEmitter();
  @Input() event: any;
  @Input() myResources: any[] = [];;
  @Input() isPopupOpen = false;
  @Input() filteredCustomers: any[] = [];;
  // @ViewChild(CalendarAdminComponent)
  // calendarAdmin!: CalendarAdminComponent;
  
  buttonText?: string;
  buttonType?: 'success' | 'warning';
  popupAnchor?: HTMLElement;
  timer?: ReturnType<typeof setTimeout>;
  eventTitle:string = '';
  categoryData = categoryData;
  statusData = statusData;
  platformIcons = platformIcons;
  missing: any;
  missingNumber: any;
  overload: boolean = false;
  intData:any;
  fremdData: any;
  isCopied:boolean = false;
  formattedStart: any;
  formattedEnd: any;
  calendarOption = getCalendarOptions(this)
  
  constructor(
    public datePipe: DatePipe, 
    public colorService: ColorService, 
    public iconService: IconService,
    private cdr: ChangeDetectorRef,
  ){
    registerLocaleData(localeDe);
  }

   public closePopupOnScroll(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
    this.tooltip?.close();
  }
  
  getFormattedTime(){
    const start = new Date(this.event.start);
    const end = new Date(this.event.end);
    this.formattedStart = this.datePipe.transform(start, 'HH:mm');
    this.formattedEnd = this.datePipe.transform(end, 'HH:mm');
  }
  
  
  getInterpreters(){
    let eventResources 
    if(this.event.isTempEvent){
      eventResources = this.event.eventResources
    }else{
      eventResources = this.event.resource
    }
    const intIds = eventResources;
    const intData = this.myResources.filter((int: { id: any; }) => {
      return intIds.includes(int.id)
    })
    return intData
  }


  getFremdData() {
    if(Array.isArray(this.event.informations) && this.event.informations.some((info: { title: string; }) => info.title === 'Fremd Dolmetscher')){
      const index = this.event.informations.findIndex(
        (info: { title: string }) => info.title === 'Fremd Dolmetscher'
      );
      const fremdData = this.event.informations[index].options;
      return fremdData;
    }
  }


  getEventStatus(event: any): string {

    if (!event) {
      return '';
    }

    if (event.isTempEvent) {

      if (!event.resourceMeta || !Array.isArray(event.resourceMeta)) {
        return '';
      }

      const found = event.resourceMeta.find(
        (resource: { id: any }) => resource.id === event.resource
      );

      if (!found) {
        return '';
      }

      const tempEventStatus = this.statusData.find(
        status => status.text === found.status
      );

      return tempEventStatus?.text || '';

    } else {

      const status = this.statusData.find(
        item => item.text === event.status
      );

      return status?.text || '';
    }
  }


  checkForMissingInterpreters(){
    //Intern Resources herausfiltern
    const filteredResources = this.event.resource.filter((resourceId: any) => {
      const resource = this.myResources.find((r: { id: any; }) => r.id === resourceId);
      return (resource?.team !== 'Intern' && resource?.team !== 'Allgemein');
    })

    const fremdLength = this.fremdData?.length || 0;
    const plannedInt = filteredResources.length + fremdLength - (fremdLength > 1 ? 1 : 0);
    const neededInt = this.event.dolmetscher ?? 1;

    if(plannedInt < neededInt){
      this.missing = true;
    }else{
      this.missing = false;
    }

    if(plannedInt > neededInt){
      this.overload = true;
    }else{
      this.overload = false;
    }
  }


  checkForMissingInterpretersTemp(){
    //Intern Resources herausfiltern
    const filteredResources = this.event.eventResources.filter((resourceId: any) => {
      const resource = this.myResources.find((r: { id: any; }) => r.id === resourceId);
      return (resource?.team !== 'Intern' && resource?.team !== 'Allgemein');
    })

    const fremdLength = this.fremdData?.length || 0;
    const plannedInt = filteredResources.length + fremdLength;
    const neededInt = this.event.dolmetscher ?? 1;

    if(plannedInt < neededInt){
      this.missing = true;
    }else{
      this.missing = false;
    }

    if(plannedInt > neededInt){
      this.overload = true;
    }else{
      this.overload = false;
    }
  }


  copyToClipboard(ticket: number){
    const ticketString = ticket.toString();
    navigator.clipboard.writeText(ticketString).then(() => {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    }).catch((err) => {
      console.error('Fehler beim Kopieren: ', err);
    });
  }


  pointerInHover = false;

  onEventHoverIn(args: MbscEventClickEvent): void {
    clearTimeout(this.timer);
    const event: MbscCalendarEvent = args.event;
    
    if(event['type'] === 'MISSIONEVENT'){
      this.event = event;
      console.log(this.event)
      this.intData = this.getInterpreters();
      this.fremdData = this.getFremdData();
      if(this.event.isTempEvent){
        this.checkForMissingInterpretersTemp();
      }else{
        this.checkForMissingInterpreters();
      }
      this.popupAnchor = args.domEvent.target.closest('.mbsc-timeline-event');
      this.tooltip.open();
      this.getFormattedTime();
    }
  }


  onEventHoverOut(): void {
    setTimeout(() => {
      if (!this.pointerInHover) {
        this.tooltip.close();
      }
      this.cdr.detectChanges();
    }, 150);
  }


  onMouseEnter(): void {
    this.pointerInHover = true
  }


  onMouseLeave(): void {
    this.pointerInHover = false;
    this.timer = setTimeout(() => {
      this.tooltip.close();
    }, 200);
    this.cdr.detectChanges()
  }


  getCustomerNames(event: any): string {
    let customers = event?.original?.customer ?? event?.customer;
    
    if (!Array.isArray(customers) || customers.length === 0) {
      return '- ?'; // kein Customer vorhanden
    }
  
    const names = customers.map(customer =>(
      customer.firstname + ' ' + customer.lastname
    )).join(' ,')

    if(names.includes('null')){
      return '- ?'
    }else{
      return names ? `${names}` : '?';
    }
  }


  getMissingFremdDolmetscher(event:any){
    if(event.informations){
      const informations = event.informations;
      const fremdDolmetscher = informations.find(
        (info: any) => info.title === 'Fremd Dolmetscher'
      );
    
      const emptyNames = fremdDolmetscher?.options?.filter(
        (option: any) => !option.name || option.name.trim() === ''
      ).length ?? 0;
    
      if(emptyNames > 0){
        return emptyNames;
      }
    }
  }


  hasValidCustomer(event: any): boolean {
  const customers = event?.original?.customer ?? event?.customer;

  if (!Array.isArray(customers)) {
    return false;
  }

  return customers.some(
    (c: any) =>
      c &&
      typeof c === 'object' &&
      c.firstname != null &&
      String(c.firstname).trim() !== '' &&
      c.lastname != null &&
      String(c.lastname).trim() !== ''
  );
}

}